import { PortalTypeEnum } from '@/types/closinglock.types';
import { defineStore } from 'pinia';
import { useCurrentUserStore } from '../current-user.store';

export const usePayoffOrderAnalyticsStore = defineStore('payoffOrderAnalytics', () => {
    const userStore = useCurrentUserStore();

    const trackPayoffsEvent = (event: string, details?: Record<string, unknown>) => {
        const payload = {
            role: userStore.currentUser?.role?.toLowerCase(),
            'portal type': PortalTypeEnum.COMPANY,
            ...details,
        };

        window.amplitude?.logEvent(event, payload);
    };

    return { trackPayoffsEvent };
});
